<template>
  <div id="bottomNavigationAnimationCardRoot" ref="bottomNavigationAnimationCardRoot">

    <JulioIcon :backplate-color-to="'#00000300'" :frontplate-color-to="'#CD867A'" :show="shouldAnimateLine"
               :scale="shouldScaleIcon"
               :style="iconTranslate"
               id="julioIcon"/>
    <JulioNetworkIcon :style="iconOpacity" id="julioNetworkIcon" :show="shouldAnimateLine" ref="julioNetworkIcon"/>
    <div id="lineContainer">
      <svg id="line" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 533.71 79.1">
        <path :class="strokeAnimation"
              d="M442.61,4H575.56a98.89,98.89,0,0,1,78.53,38.75l12.34,13.81a58.25,58.25,0,0,0,85.24,1.76l15.11-15.57A113.11,113.11,0,0,1,852,4c24.9,0,41.28-.22,124.3,0"
              transform="translate(-442.61 -0.4)" style="fill:none;stroke:#263238;stroke-width:7px"/>
      </svg>
    </div>
    <div id="titleContainer">
      <div id="featureTitle"><span v-html="name"></span></div>
      <div id="featureTitleDescription"><span v-html="description"></span>
      </div>
    </div>
  </div>
</template>

<script>
import JulioIcon from "../icons/JulioIcon";
import JulioNetworkIcon from "../icons/JulioNetworkIcon";

export default {
  name: "BottomNavigationAnimationCard",
  components: {JulioNetworkIcon, JulioIcon},
  props: {
    height: {
      type: Number,
      default: 0
    },

    name: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    taglineDescription: {
      type: String,
      default: ""
    },
    tagline: {
      type: String,
      default: ""
    },
    content: {
      type: Object,
    },
  },
  data() {
    return {
      shouldAnimateLine: false,
      shouldScaleIcon: 1,
    }
  },
  computed: {
    offset() {
      return this.$store.state.scrollOffset
    },
    iconAnimate: {
      set: function (newValue) {
        this.shouldAnimateLine = newValue;
      },
      get: function () {
        return this.shouldAnimateLine;
      }
    },
    iconScale: {
      set: function (newValue) {
        this.shouldScaleIcon = newValue;
      },
      get: function () {
        return this.shouldScaleIcon;
      }
    },
    iconTranslate() {
      let position = 0;
      if (this.height >= 1366)
        position = (this.offset - (this.height * 2.2))
      else if (this.height >= 1020 && this.height < 1366)
        position = (this.offset - (this.height * 2.8))
      else if (this.height >= 898 && this.height < 1020)
        position = (this.offset - (this.height * 3.3))
      else if (this.height >= 812 && this.height < 898)
        position = (this.offset - (this.height * 3.3))
      else if (this.height > 640 && this.height < 812)
        position = (this.offset - (this.height * 3.9))
      else
        position = (this.offset - (this.height * 4.2))
      if (position < 0) {
        this.animateIcon(false)
        return {
          transform: `translateY(${position}px) !important`,
          'webkit-transform': `translateY(${position}px) !important`,
          '-moz-transform': `translateY(${position}px) !important`,
          '-o-transform': `translateY(${position}px) !important`,
          '-ms-transform': `translateY(${position}px) !important`,
          transition: `fill 0.3s ease-out !important`,
          '-webkit-transition': `fill 0.3s ease-out !important`,
          '-o-transition': `fill 0.3s ease-out !important`,
          '-moz-transition': `fill 0.3s ease-out !important`
        }
      } else {
        this.animateIcon(true)
        return {
          transform: `translateY(0%) !important`

        }
      }
    },
    iconOpacity() {
      if (this.iconAnimate) {
        return {
          opacity: '100%',
          transition: `0.2s ease-out !important`,
          '-webkit-transition': `0.2s ease-out !important`,
          '-o-transition': `0.2s ease-out !important`,
          '-moz-transition': `0.2s ease-out !important`
        }
      } else {
        return {
          opacity: '0',
          transition: `none`,
          '-webkit-transition': `none`,
          '-o-transition': `none`,
          '-moz-transition': `none`
        }
      }
    },
    strokeAnimation() {
      return {
        iconRevealFromStart: this.shouldAnimateLine,
        iconHideFromStart: !this.shouldAnimateLine
      }
    }
  },
  methods: {
    animateIcon(state) {
      if (state)
        this.iconScale = 1.3
      else
        this.iconScale = 1
      this.iconAnimate = state
    }
  },
}
</script>

<style lang="scss" src="../../styles/bottomnavigationanimation.scss" scoped/>